/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import * as styles from './style';


interface INotificationProps {
    handleActionClick: () => any;
    message: string;
    actionText: string;
    isSuccess?: boolean;
}

export const WorkoutNotification: React.FC<INotificationProps> = (props: INotificationProps) => {
    const { message, actionText, handleActionClick, isSuccess } = props;

    return (
        <div css={styles.notificationContainer}>
            <div css={styles.notificationLeft}>
                <img src={isSuccess ? "/images/icons/check.svg" : "/images/Assessment_done.svg"} />
                <div css={styles.successText}>{message}</div>
            </div>
            <div css={styles.notificationRight}>
                <div css={styles.notificationActionTop} onClick={handleActionClick}>
                    {actionText}
                </div>
            </div>
        </div>
    )
}